import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const orientacionModule = {
	state: {
		orientacion : []
	},
	getters: {  
        getorientacion : state => state.orientacion
	},
	actions: {
		requestorientacion({ commit, dispatch }) {
            return new Promise((resolve, reject) => {

                axios.get('/api/Alumno/dameGuiasOrientacion/1').then(result => {

                    if (result.data.status == 0) {

                        if (result.data.datos.numPaginas != 1) {
                            let data = {
                                max: result.data.datos.numPaginas,
                                page: 2
                            }
                            dispatch('requestMoreOrientacion', data);
                        }
                        commit('setorientacion', result.data.datos.guias)

                    } else {
                        commit('setError', result.data.status)
                        reject(false);
                    }

                }).catch(error => {

                });
            });
        },
        requestMoreOrientacion({ commit, dispatch }, data) {

            return new Promise((resolve, reject) => {

                if (data.page <= data.max) {

                    axios.get('/api/Alumno/dameGuiasOrientacion/' + data.page).then(result => {

                        if (result.data.status == 0) {
                            commit('setorientacion', result.data.datos.guias);
                            data.page++;
                            dispatch('requestMoreOrientacion', data);
                            resolve(true);
                        } else {
                            commit('setError', result.data.status)
                            reject(false);
                        }

                    }).catch(error => {

                    });

                } else {
                    resolve(true)
                }
            });
        },
	},
	mutations: {
        setorientacion(state, orientacion){
			state.orientacion = state.orientacion.concat(orientacion);
        }
	}
}

export default orientacionModule;


// WEBPACK FOOTER //
// ./src/store/orientacionModule.js